import React from 'react';
import { DivPreview, ImgPreview } from './cameraStyle';


function ImagePreview({ dataUri, isFullscreen }) {
  return (
    <DivPreview>
      <ImgPreview src={dataUri} alt="Signature selfie" />
    </DivPreview>
  );
}

export default ImagePreview;
